import { FC } from 'react'
import { Navigate, Outlet } from 'react-router'
import { useAuth } from '@/application/auth/hooks/useAuth'
import { UserRole } from '@/application/auth/types/userRole'

type RoleProtectedRouteProps = {
  roles: UserRole[]
}

// This component redirects to the forbidden page if the user has none of the required roles
export const RoleProtectedRoute: FC<RoleProtectedRouteProps> = ({ roles }: RoleProtectedRouteProps) => {
  const { isAuthenticated, hasAnyRole } = useAuth()

  if (!isAuthenticated) {
    return null
  }

  if (!hasAnyRole(roles)) {
    return <Navigate to="/forbidden" replace />
  }

  return <Outlet />
}
